<app-wizard [index]="stepIndex" [steps]="steps"></app-wizard>
<div class="ot-wizard-panel-body">
  <ng-scrollbar #scrollbarRef>
    <div [hidden]="state !== PlansExecutionState.VALIDATE" animate.enter="enter-animation">
      @if (isValidating) {
      <div class="ot-message ot-message--is-progress w-100">
        <div class="ot-message__banner">
          <p class="ot-message__item" i18n id="otsc-plan-execution-validating-msg">
            Validating the steps. Please wait...
          </p>
        </div>
      </div>
      }
      @if (!isValidating) {
      <div class="ot-message w-100"
        [ngClass]="{'ot-message--is-success': preReqErrors.length == 0, 'ot-message--is-error': preReqErrors.length > 0}">
        <div class="ot-message__banner">
          @if (preReqErrors.length == 0) {
          <p class="ot-message__item" i18n id="otsc-plan-execution-validation-result-msg" i18n>
            The plan has been validated successfully. Click Next to continue.
          </p>
          }
          @if (preReqErrors.length > 0) {
          <p class="ot-message__item" i18n id="otsc-plan-execution-validation-result-msg" i18n>
            The validation errors must be corrected before continuing. &nbsp;<a id="otsc-plan-execution-edit-plan"
              title="Edit plan" i18n-title (click)="goToPlanDetails()">Edit plan</a>
          </p>
          }
        </div>
      </div>
      }
      <app-datatable [title]="validationErrorTableTitle" [identifier]="'otsc-plans-execution-validation-errors-table'"
        [isloading]="isValidating" [cols]="cols" [rows]="rows" [scroll]="false"></app-datatable>
    </div>
    <div [hidden]="state !== PlansExecutionState.REVIEW" animate.enter="enter-animation">
      <div class="ot-message w-100 ot-message--is-warning">
        <div class="ot-message__banner">
          <p class="ot-message__item" i18n>
            Please review and enter the required parameters for each step.
          </p>
        </div>
      </div>
      <div>
        <div class="ot-level">
          <div class="ot-level__left"></div>
          <div class="ot-level__center"></div>
          <div class="ot-level__right">
            <div class="ot-level__item ot-pr-2">
              <div class="ot-mb-0 ot-pt-1">
                <app-checkbox [identifier]="'toggle-param-password'" [name]="'togglePassword'" [(ngModel)]="togglePwd"
                  (ngModelChange)="onTogglePwdCheckbox()" i18n-label [label]="'Show values'" i18n-arialabel
                  [arialabel]="'Show values'">
                </app-checkbox>
              </div>
            </div>
          </div>
        </div>
        <app-datatable [title]="reviewTableTitle" [identifier]="'otsc-plans-execution-table'" [cols]="stepCols"
          [rows]="stepRows" [isloading]="isStepTableLoading" (onchangeinput)="onParamValueChange($event)"
          [scroll]="false" [showIconColumn]="true"></app-datatable>
      </div>
    </div>
    <div [hidden]="state !== PlansExecutionState.EXECUTE" animate.enter="enter-animation">
      <div class="ot-message w-100 ot-message--is-success">
        <div class="ot-message__banner">
          <p class="ot-message__item" i18n>
            {{plan.name}} plan is ready to be executed.
          </p>
        </div>
      </div>
      <div style="height: calc(100vh - 307px)">
      </div>
    </div>
  </ng-scrollbar>
</div>
<!-- footer -->
<div class="ot-wizard-panel-footer"
  [ngClass]="{'ot-flex--is-space-between' : stepIndex > 0, 'ot-wizard-panel-footer--is-right-justified' : stepIndex == 0}">
  <div role="group" class="ot-btn-group" style="position: fixed;right: 15px">
    <button role="button" [id]="nextButtonId" i18n-title title="Next" class="ot-btn ot-btn--is-primary"
      (click)="goToNextState()" [disabled]="isDisableNextBtn()">
      {{nextButton}}
    </button>
    <button id="otsc-plan-execution-cancel-btn" role="button" i18n-title title="Cancel"
      class="ot-btn ot-btn--is-secondary" (click)="cancelPlansExecutionWizard()" i18n>
      Cancel
    </button>
  </div>
  @if (stepIndex > 0) {
  <button [id]="prevButtonId" role="button" (click)="goToPrevState()" aria-label="Back" i18n-title title="Back"
    class="otsc-btn__back ot-mb-1 ot-btn ot-btn--is-micro ot-btn--is-icon-btn ot-ml-1" style="margin-top: 14px">
    <div class="otsc-back_btn"></div>
  </button>
  }
</div>